import {
	GET_RULE_SET_OPTIONS_COMPLETE,
	INIT_SPORT_DATA,
	INIT_SPORT_DATA_COMPLETE
} from "./constants";

const initialState = {
	allowedPositions: [],
	allowedYears: [],
	ruleSetOptions: []
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case INIT_SPORT_DATA: {
			return {
				...state,
				isLoading: true
			};
		}
		case GET_RULE_SET_OPTIONS_COMPLETE:
		case INIT_SPORT_DATA_COMPLETE:
			return {
				...state,
				...payload,
				isLoading: false
			};
		default:
			return state;
	}
};

export default reducer;
